import { Row, Col, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import stepIndicator from "../../../assets/img/stepIndicator.png";
import simplerevonate_bg_img from "../../../assets/img/simple-bg-img.svg";
import banner_home from "../../../assets/img/banner_home_new.png";
import Rightbid from "../../../assets/img/Rightbid.svg";
import Virtuallybid from "../../../assets/img/Virtuallybid.svg";
import Uploadproject from "../../../assets/img/Uploadproject.svg";
import Renovationprocess from "../../../assets/img/Simplified Renovation1.svg";
import Savetime from "../../../assets/img/Save time1.svg";
import Smartbidding from "../../../assets/img/Smart technology1.svg";
import BackgroundShadow from "../../../assets/img/Background+Shadow.svg";
import Hand from "../../../assets/img/Trusted Professionals1.svg";
import people from "../../../assets/img/people.svg";
import people1 from "../../../assets/img/people 1.svg";
import people2 from "../../../assets/img/people 2.svg";
import TrustVerification from "../../../assets/img/Trust & Verification.svg";
import Network from "../../../assets/img/Expanding Network.svg";
import Workflow from "../../../assets/img/Simplified Workflow.svg";
import Measurement from "../../../assets/img/Smart Measurement.svg";
import line_dash from "../../../assets/img/line img.svg";

const Home = () => {
  const parseStoredJson = (key) => {
    try {
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  };

  const pathVariants = {
    hidden: { strokeDasharray: 600, strokeDashoffset: 600, opacity: 0 },
    visible: {
      strokeDashoffset: 0,
      opacity: 1,
      transition: {
        duration: 3,
        ease: "easeInOut",
      },
      //   filter: "drop-shadow(2px 2px 2px rgba(0,0,0,0.5))"
    },
  };

  const navigate = useNavigate();
  const clientData = parseStoredJson("clientData");
  const professionalData = parseStoredJson("professionalData");

  useEffect(() => {
    if (
      localStorage.getItem("clientToken") &&
      clientData?.profileSteps === 2
    ) {
      navigate("/client/dashboard");
    } else if (
      localStorage.getItem("professionalToken") &&
      professionalData?.profileSteps === 4
    ) {
      navigate("/professional/dashboard");
    }
    // Any side effects or data fetching can be done here
  }, [clientData?.profileSteps, professionalData?.profileSteps, navigate]);

  const testimonials = [
    {
      name: "Marcus T., Client in Huntington Beach, CA",
      feedback:
        "Didn’t have to schedule visits or deal with pressure. I scanned my space, got bids online, and picked the best one. Easiest home project I’ve done.",
      // image: images.Avatar.default,
    },
    {
      name: "James L., Flooring Professional in Tallahassee, FL",
      feedback:
        "SimpleRenovate saves me hours. Having all the dimensions and project details upfront means I can quote jobs faster without wasting time on site visits.",
      // image: images.Avatar.default,
    },
    {
      name: "Sofia R., Client in Phoenix, AZ",
      feedback:
        "I loved that I didn’t have to let anyone into my home just to get a quote. SimpleRenovate let me post everything from my phone—fast, easy, and zero pressure.",
      // image: images.Avatar.default,
    },
  ];

  const [activeCard, setActiveCard] = useState(0);

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const navigateToClientCta = () => {
    handleViewDetails();
    if (localStorage.getItem("clientToken")) {
      navigate("/client/dashboard");
      return;
    }
    navigate("/select-role", {
      state: { clickBy: "Client" },
    });
  };

  const navigateToProfessionalCta = () => {
    handleViewDetails();
    if (localStorage.getItem("professionalToken")) {
      navigate("/professional/jobs");
      return;
    }
    navigate("/select-role", {
      state: { clickBy: "Professional" },
    });
  };

  return (
    <>
      <div className="main main_home">
        <div
          style={{ backgroundColor: "#fafbfc", paddingBottom: "40px" }}
          className="padding_top"
        >
          <div className="hero-width custom_container">
            <div className="hero-width hero pt-2 pt-lg-5 mb-3">
              <div className="row no-gutters">
                <div className="col-6 col-sm-6 col-md-6 col-md-style">
                  <div className="worker-logo">
                    <img
                      src={banner_home}
                      alt="Worker"
                      className="worker-logo-img"
                    />
                  </div>
                  {/* <div className="worker-logo-md">
                    <img
                      src={banner_home1}
                      alt="Worker"
                      className="worker-logo-img"
                    />
                  </div> */}
                </div>

                <div className="col-6 col-sm-6 col-md-6 d-flex align-items-center justify-content-start">
                  <div className="hero-content me-0">
                    <h2>
                      The future of
                      <br />
                      <span>renovation is here</span>
                    </h2>
                    <p className="hero-subtitle">
                      Measure. Upload. Get bids. Stress-free.
                    </p>
                    <div className="hero-buttons mt-3">
                      <button
                        type="button"
                        className="get-bids btn btn-primary"
                        onClick={navigateToClientCta}
                      >
                        Get Bids
                      </button>

                      <button
                        type="button"
                        className="bid-jobs btn btn-secondary"
                        onClick={navigateToProfessionalCta}
                      >
                        Bid on Jobs
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="custom_container section_2">
          <Col
            md={12}
            className="how-it-works ms-0 justify-content-center align-items-center"
          >
            <h2>
              Your Renovation,
              <br />
              <span> Simplified</span>.
            </h2>
            <p className="hero-subtitle">
              We’ve streamlined the renovation process to make it faster,
              smarter, and easier
              <br /> than ever.
            </p>
          </Col>
          <div className="choose-box mt-2 mt-sm-3 header_drop_down_style">
            <Row className="features mt-3 mb-0 mb-lg-5">
              <Col lg={3} md={6} xs={6} className="feature-card feature-card-2">
                <div className="card-container">
                  <img
                    src={TrustVerification}
                    alt="Smart Technology Icon"
                    className="icon my-3"
                  />
                  <h6 className="fw-bold">Trust & Verification</h6>
                  <p>Verified businesses with track records you can review.</p>
                </div>
              </Col>
              <Col lg={3} md={6} xs={6} className="feature-card feature-card-2">
                <div className="card-container">
                  <img
                    src={Measurement}
                    alt="Smart Technology Icon"
                    className="icon my-3"
                  />
                  <h6 className="fw-bold">Smart Measurement</h6>
                  <p>
                    Use your phone to scan and create 2D/3D layouts that pros
                    use to send accurate bids.
                  </p>
                </div>
              </Col>
              <Col lg={3} md={6} xs={6} className="feature-card feature-card-2">
                <div className="card-container">
                  <img
                    src={Workflow}
                    alt="Smart Technology Icon"
                    className="icon my-3"
                  />
                  <h6 className="fw-bold">Simplified Workflow</h6>
                  <p>From scan to quote in a few easy steps.</p>
                </div>
              </Col>
              <Col lg={3} md={6} xs={6} className="feature-card feature-card-2">
                <div className="card-container">
                  <img
                    src={Network}
                    alt="Smart Technology Icon"
                    className="icon my-3"
                  />
                  <h6 className="fw-bold">Expanding Network</h6>
                  <p>
                    More verified professionals joining everyday, ready to quote
                    your next project.
                  </p>
                </div>
              </Col>
              <div className="d-flex justify-content-center gap-3 mt-3 mt-sm-4">
                <Button
                  variant="danger"
                  className="get-bids btn btn-primary"
                  onClick={navigateToClientCta}
                >
                  Get Bids
                </Button>
                <Button
                  type="button"
                  className="bid-jobs btn btn-secondary"
                  onClick={navigateToProfessionalCta}
                >
                  Bid on Jobs
                </Button>
              </div>
            </Row>
          </div>
        </div>

        <div className="home-section-shell position-relative simplerevonate_bg_img">
          <div className="custom_container hero-width position-relative mt-0 mt-lg-4 mt-xl-5">
            <motion.svg
              className="position-absolute path-svg svg_style"
              width="100%"
              height="1130"
              viewBox="50 -78 320 400"
              xmlns="http://www.w3.org/2000/svg"
              initial="hidden"
              animate="visible"
              style={{
                filter: "drop-shadow(4px 10px 5px rgba(0, 0, 0, 0.5))",
              }}
            >
              <motion.path
                d="M0 150 C 210 180, 90 70, 220 70 S 260 -10, 400 0"
                variants={pathVariants}
                stroke="#CC4645"
                strokeWidth="2"
                fill="transparent"
                strokeLinecap="round"
              />

              <motion.image
                href={stepIndicator}
                x="25"
                y="148"
                width="10"
                height="10"
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.1, duration: 0.5 }}
              />

              <motion.image
                href={stepIndicator}
                x="180"
                y="69"
                width="10"
                height="10"
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 1, duration: 0.5 }}
              />

              <motion.image
                href={stepIndicator}
                x="350"
                y="-5"
                width="10"
                height="10"
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 1.8, duration: 0.5 }}
              />
            </motion.svg>

            <div className="home-width align-items-center">
              <img
                src={simplerevonate_bg_img}
                alt="simplerevonate_bg_img"
                className="simple_img"
              />
              <Row className="align-items-center">
                <Col className="p-0 how-it-works how-it-works-container d-flex justify-content-center how-it-works-container position-relative pt-0 pt-xl-5">
                  <div className="me-0 me-lg-3">
                    <h3 className="mt-0 mt-sm-3 mt-md-5 text-start">
                      HOW IT WORKS
                    </h3>
                    <h2 className="text-start">
                      SimpleRenovate is free to clients and simple to use
                    </h2>
                    <h5 className="text-start">
                      Where virtual quotes from real professionals are <br />
                      right at your fingertips.
                    </h5>
                    <div className="hero-buttons">
                      <Button
                        variant="danger"
                        className="get-bids btn btn-primary"
                        onClick={navigateToClientCta}
                      >
                        Get Bids
                      </Button>
                    </div>
                  </div>

                  <div className="card_flex_home_sec">
                    <div className="road_map_point_3">
                      <span className="number_3">3</span>

                      {/* Foreground content */}
                      <div style={{ position: "relative", zIndex: 1 }}>
                        <img
                          src={Rightbid}
                          alt="Smart Bidding Icon"
                          style={{
                            width: "30px",
                            height: "30px",
                            marginBottom: "10px",
                          }}
                        />
                        <h6
                          className="fw-bold text-dark points_font"
                          style={{ fontSize: ".95rem" }}
                        >
                          Choose the right bid and get started.
                        </h6>
                        <p
                          className="text-secondary"
                          style={{ fontSize: "0.75rem", lineHeight: "1.7" }}
                        >
                          Review bids from top professionals and select the one
                          that works best for you. Once chosen, your project
                          moves forward—quickly and stress-free.
                        </p>
                      </div>
                    </div>
                    <div className="road_map_point_2">
                      <span className="number_2">2</span>

                      <div style={{ position: "relative", zIndex: 1 }}>
                        <img
                          src={Virtuallybid}
                          alt="Smart Bidding Icon"
                          style={{
                            width: "30px",
                            height: "30px",
                            marginBottom: "10px",
                          }}
                        />
                        <h6
                          className="fw-bold text-dark points_font"
                          style={{ fontSize: ".95rem" }}
                        >
                          Professionals bid virtually.{" "}
                        </h6>
                        <p
                          className="text-secondary"
                          style={{ fontSize: "0.75rem", lineHeight: "1.7" }}
                        >
                          Once your project is posted, professionals review your
                          detailed job information and submit bids virtually.
                          You stay in control by selecting the professionals you
                          want to connect with—no pressure, just results.
                        </p>
                      </div>
                    </div>
                    <div className="road_map_point_1">
                      <span className="number_1">1</span>

                      {/* Foreground content */}
                      <div style={{ position: "relative", zIndex: 1 }}>
                        <img
                          src={Uploadproject}
                          alt="Smart Bidding Icon"
                          style={{
                            width: "30px",
                            height: "30px",
                            marginBottom: "10px",
                          }}
                        />
                        <h6
                          className="fw-bold text-dark points_font"
                          style={{ fontSize: ".95rem" }}
                        >
                          Measure and upload project details.{" "}
                        </h6>
                        <p
                          className="text-secondary"
                          style={{ fontSize: "0.75rem", lineHeight: "1.7" }}
                        >
                          Measure your space using SimpleRenovate’s advanced
                          smartphone camera technology and upload detailed
                          project information. Your job post will include
                          precise measurements and all the details professionals
                          need to bid effectively.
                        </p>
                      </div>
                    </div>
                    {/* <img src={line_dash} alt="line" className="line_dash" /> */}
                  </div>
                </Col>
              </Row>
            </div>

            <Col
              md={12}
              className="how-it-works mt-5 ms-0 justify-content-center align-items-center"
            >
              <h2 className="pt-3 pt-sm-4 pt-xl-0">
                Why Choose SimpleRenovate
              </h2>
              <h3 style={{ fontWeight: "400" }}>
                We're committed to making your renovation experience smooth,
                reliable, and stress-
                <br />
                free.
              </h3>
            </Col>
            <div className="choose-box mt-2 mt-sm-3 mt-md-4 mt-lg-5 header_drop_down_style">
              <Row className="features mb-4 mb-md-5">
                <Col
                  lg={3}
                  xs={6}
                  className="feature-card mb-3 mb-md-0"
                  onClick={() => setActiveCard(0)}
                >
                  <div
                    className="card-container"
                    style={{
                      border:
                        activeCard == 0
                          ? "1px solid #9a1d1c"
                          : "1px solid transparent",
                    }}
                  >
                    <img
                      src={Renovationprocess}
                      alt="Smart Technology Icon"
                      className="icon mt-2 mt-sm-3"
                    />
                    <h6
                      className="fw-bold height_choose_h6_style"
                      style={{
                        color: activeCard == 0 ? "#cc4645" : "#000",
                        background:
                          activeCard == 0
                            ? "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)"
                            : "none",
                        WebkitBackgroundClip: activeCard == 0 ? "text" : "none",
                        WebkitTextFillColor:
                          activeCard == 0 ? "transparent" : "initial",
                        backgroundClip: activeCard == 0 ? "text" : "none",
                      }}
                    >
                      Simplified Renovation Process{" "}
                    </h6>
                    <p className="height_choose_para_style">
                      Measure your space, upload project details, and get
                      bids—all from the comfort of your home.{" "}
                    </p>
                  </div>
                </Col>{" "}
                <Col
                  lg={3}
                  xs={6}
                  className="feature-card mb-3 mb-md-0"
                  onClick={() => setActiveCard(1)}
                >
                  <div
                    className="card-container"
                    style={{
                      border:
                        activeCard == 1
                          ? "1px solid #9a1d1c"
                          : "1px solid transparent",
                    }}
                  >
                    <img
                      src={Hand}
                      alt="Smart Technology Icon"
                      className="icon mt-2 mt-sm-3"
                    />
                    <h6
                      className="fw-bold height_choose_h6_style"
                      style={{
                        color: activeCard == 1 ? "#cc4645" : "#000",
                      }}
                    >
                      Trusted Professionals at your Fingertips{" "}
                    </h6>
                    <p className="height_choose_para_style">
                      Connect with licensed, verified experts who are ready to
                      make your project a reality.{" "}
                    </p>
                  </div>
                </Col>{" "}
                <Col
                  lg={3}
                  xs={6}
                  className="feature-card mb-3 mb-sm-0"
                  onClick={() => setActiveCard(2)}
                >
                  <div
                    className="card-container"
                    style={{
                      border:
                        activeCard == 2
                          ? "1px solid #9a1d1c"
                          : "1px solid transparent",
                    }}
                  >
                    <img
                      src={Savetime}
                      alt="Smart Technology Icon"
                      className="icon mt-2 mt-sm-3"
                    />
                    <h6
                      className="fw-bold height_choose_h6_style"
                      style={{
                        color: activeCard == 2 ? "#cc4645" : "#000",
                      }}
                    >
                      Save Time and Eliminate Hassle{" "}
                    </h6>
                    <p className="height_choose_para_style">
                      No in-home visits, no high-pressure sales tactics just
                      fast, accurate bids.{" "}
                    </p>
                  </div>
                </Col>
                <Col
                  lg={3}
                  xs={6}
                  className="feature-card mb-3 mb-sm-0"
                  onClick={() => setActiveCard(3)}
                >
                  <div
                    className="card-container"
                    style={{
                      border:
                        activeCard == 3
                          ? "1px solid #9a1d1c"
                          : "1px solid transparent",
                    }}
                  >
                    <img
                      src={Smartbidding}
                      alt="Smart Technology Icon"
                      className="icon mt-2 mt-sm-3"
                    />
                    <h6
                      className="fw-bold height_choose_h6_style"
                      style={{
                        color: activeCard == 3 ? "#cc4645" : "#000",
                      }}
                    >
                      Smart Technology for Smarter Bidding
                    </h6>
                    <p className="height_choose_para_style">
                      Our advanced camera measurement tools ensure precise
                      details, making the process seamless for everyone.
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <div className="custom_container">
          <Col
            md={12}
            className="how-it-works mt-5 ms-0 justify-content-center align-items-center home_testimonial"
          >
            {/* <p>
              <span>Built to save time for clients and pros alike</span>
            </p>
            <h2>People love renovating with us</h2> */}
            <h3 style={{ color: "#4b5563" }}>
              We match homeowners with trusted pros—fast. No pressure, no sales
              calls—just clear <br />
              measurements, fair bids, and smooth projects from start to finish.
            </h3>
          </Col>
          {/* <div className="choose-box mt-2 mt-sm-3 header_drop_down_style">
            <Row className="features mt-0 mt-sm-3 mt-md-4 mt-lg-5 mb-4 mb-sm-5">
              <Col
                lg={4}
                md={6}
                sm={12}
                className="feature-card feature-card-2"
              >
                <div className="card-container card-container-2 card-container-3 ">
                  <img
                    src={BackgroundShadow}
                    alt="Smart Technology Icon"
                    className="icon my-0 my-sm-3"
                  />
                  <p className="text-dark text-start">
                    Didn’t have to schedule visits or deal with pressure. I
                    scanned my space, got bids online, and picked the best one.
                    Easiest home project I’ve done.
                  </p>
                  <div className="d-flex align-items-center justify-content-start mt-3 mt-sm-4 w-100 gap-2">
                    <img src={people} alt="people" />
                    <div
                      style={{
                        textAlign: "start",
                        height: "100%",
                      }}
                    >
                      <h5 className="fw-bold text-start">Marcus T.</h5>
                      <span style={{ color: "#4b5563", fontWeight: "bold" }}>
                        Client in Queen Creek, AZ
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col
                lg={4}
                md={6}
                sm={12}
                className="feature-card feature-card-2"
              >
                <div className="card-container card-container-2 card-container-3">
                  <img
                    src={BackgroundShadow}
                    alt="Smart Technology Icon"
                    className="icon my-0 my-sm-3"
                  />
                  <p className="text-dark text-start">
                    SimpleRenovate saves me hours. Having all the dimensions and
                    project details upfront means I can quote jobs faster
                    without wasting time on site visits.
                  </p>
                  <div className="d-flex align-items-center justify-content-start mt-3 mt-sm-4 w-100 gap-2">
                    <img src={people1} alt="people" />
                    <div style={{ textAlign: "start" }}>
                      <h5 className="fw-bold text-start">James L.</h5>
                      <span style={{ color: "#4b5563", fontWeight: "bold" }}>
                        Flooring Professional in Saint Paul, MN
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col
                lg={4}
                md={6}
                sm={12}
                className="feature-card feature-card-2"
              >
                <div className="card-container card-container-2 card-container-3">
                  <img
                    src={BackgroundShadow}
                    alt="Smart Technology Icon"
                    className="icon my-0 my-sm-3"
                  />
                  <p className="text-dark text-start">
                    I loved that I didn’t have to let anyone into my home just
                    to get a quote. SimpleRenovate let me post everything from
                    my phone—fast, easy, and zero pressure.
                  </p>
                  <div className="d-flex align-items-center justify-content-start mt-3 mt-sm-4 w-100 gap-2">
                    <img src={people2} alt="people" />
                    <div style={{ textAlign: "start" }}>
                      <h5 className=" fw-bold text-start">Sofia R.</h5>
                      <span style={{ color: "#4b5563", fontWeight: "bold" }}>
                        Client in Huntington Beach, CA
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <div className="d-flex justify-content-center">
                <Button
                  variant="danger"
                  className="get-bid2 btn btn-primary"
                  onClick={navigateToClientCta}
                >
                  Join Thousands of Happy Customers
                </Button>
              </div>
            </Row>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Home;
